import { Injectable } from "@angular/core";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { LoadingDialogComponent } from "../components/loading-dialog/loading-dialog.component";

@Injectable()
export class LoadingDialogService {
  private opened = false;
  private dialogRef!: MatDialogRef<LoadingDialogComponent>;

  /**
   * Constructor
   * @param dialog Dialog instance
   */
  constructor(private dialog: MatDialog) {}

  /**
   * Open dialog
   */
  openDialog(): void {
    if (!this.opened) {
      this.opened = true;
      this.dialogRef = this.dialog.open(LoadingDialogComponent, {
        restoreFocus:false,
        data: undefined,
        maxHeight: "100%",
        width: "400px",
        maxWidth: "100%",
        disableClose: true,
        hasBackdrop: true
      });
      this.dialogRef.afterClosed().subscribe(() => {
        this.opened = false;
      });
      
    }
  }

  /**
   * Hide dialog
   */
  hideDialog() {
    this.dialogRef.close();
  }
}
